/* lp-haartest.js — Klaviyo client-side subscribe handler for notify-form */
(function () {
  'use strict';

  function initForm(form) {
    if (form.dataset.lphirInitialized === '1') return;
    form.dataset.lphirInitialized = '1';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var listId = form.dataset.klaviyoList || '';
      var companyId = form.dataset.klaviyoCompany || '';
      var successText = form.dataset.successText || 'Tak!';
      var errorText = form.dataset.errorText || 'Noget gik galt. Prøv igen.';
      var loadingText = form.dataset.loadingText || 'Sender…';
      var notConfiguredText = form.dataset.notConfiguredText || 'Formularen er ikke konfigureret endnu.';
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');

      if (!input || !button || !input.value.trim()) return;

      if (!listId || !companyId) {
        showError(form, notConfiguredText);
        return;
      }

      var originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = loadingText;
      clearError(form);

      var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: input.value.trim() }
              }
            },
            custom_source: 'Hårtest landingside — coming soon'
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'revision': '2024-10-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.ok) {
            showSuccess(form, successText);
          } else {
            button.disabled = false;
            button.textContent = originalLabel;
            showError(form, errorText);
            input.focus();
          }
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalLabel;
          showError(form, errorText);
          input.focus();
        });
    });
  }

  function showSuccess(form, message) {
    var success = document.createElement('div');
    success.className = 'lphir-success';
    success.setAttribute('role', 'status');
    success.textContent = message;
    form.parentNode.replaceChild(success, form);
  }

  function showError(form, message) {
    clearError(form);
    var error = document.createElement('div');
    error.className = 'lphir-error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    form.insertAdjacentElement('afterend', error);
  }

  function clearError(form) {
    var existing = form.parentNode.querySelector('.lphir-error');
    if (existing) existing.remove();
  }

  function init() {
    try {
      var forms = document.querySelectorAll('.lphir-form');
      for (var i = 0; i < forms.length; i++) initForm(forms[i]);
    } catch (err) {
      console.error('lp-haartest init failed:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
